import { ActionContext } from 'vuex';

import { IRootState } from '@/store';
import {  ActionTree } from 'vuex';
import {
    createCollaborators,
    estimatedWithdraws,
    getCollaborators,
    getListHistoriesCollaborators,
    getListUserInvite, withdraws,
} from '../services';
import { ICollaboratorsState } from '@/modules/collaborators/store/collaborators';
import { uploadKyc } from '@/modules/auth/services';


// @ts-ignore
const collaboratorsAction: ActionTree<ICollaboratorsState,IRootState> = {
    async getListUserInviteApi(context: ActionContext<ICollaboratorsState, IRootState>, params)  {
        return await getListUserInvite(params);
    },
    async getListHistoriesCollaboratorsApi(context: ActionContext<ICollaboratorsState, IRootState>, params)  {
        return await getListHistoriesCollaborators(params);
    },
    async getCollaboratorsApi(context: ActionContext<ICollaboratorsState, IRootState>, params)  {
        return await getCollaborators();
    },
    async createCollaboratorsApi(context: ActionContext<ICollaboratorsState, IRootState>, params)  {
        return await createCollaborators();
    },
    async estimatedWithdrawsApi(context: ActionContext<ICollaboratorsState, IRootState>, params)  {
        const response = await estimatedWithdraws(params);
        return response;
    },
    async withdrawsApi(context: ActionContext<ICollaboratorsState, IRootState>, params)  {
        const response = await withdraws(params);
        return response;
    }
}
export default collaboratorsAction;
